import {React, useState, useEffect, useCallback } from "react";
import MuiTable from "../common/MuiTable";
import { FxmsData } from "../../fxms/datas/FxData";
import { UI_5_4_tableRow } from "./helper/UI_5_4.helper";
import { FxWindow } from "../../fxms/windows/FxWindows";
import { FxOpenButton } from "./../../fxms/inputs/FxOpenButton";

/*관리자>Q&A 조회*/
export const UI_5_4 = (props) => {
  const opObjCheck = FxmsData.getOpObj("ui-5-4-detail");
  const [selected, setSelected] = useState({
    qnaMenuClCd: "ALL",
    qnaClCd: "TITLE",
    txtSearch: "",
  });   
  const [fetchData, setFetchData] = useState([]);
  const [fetchQnaMenuClCd, setFetchQnaMenuClCd] = useState([]);

  const submitBtnClick = useCallback(async () => {
    const param = {
        qnaMenuClCd: selected.qnaMenuClCd,
        qnaClCd: selected.qnaClCd,
        txtSearch: selected.txtSearch,
    }

    try {
      const uri = "vup/select_5_4";
      const res = await FxmsData.GET(uri, param);

      FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");

      setFetchData(res.data);
    } catch (e) {
      console.log("UI_5_4 fetchData error", e);
    }
  }, [selected]);

  const dataGrid = (
        qnaNo,      // 번호    
        complexInloName, // 복합명
        companyInloName, // 회사명
        plantInloName, // 사업장명
        qnaMenuClCd,    // 문의분류
        qnaTitle,   // 제목
        regDtm,     // 등록일시
        qnaStCd,    // 진행상태
        answerBtn,    // 답변 버튼
    ) => {
        return {
            qnaNo,
            complexInloName,
            companyInloName,
            plantInloName,
            qnaMenuClCd,
            qnaTitle,
            regDtm,
            qnaStCd,
            answerBtn,
        };
    };

  const resultRow = fetchData.map(item => {
    return dataGrid(
        item.qnaNo,
        item.complexInloName,
        item.companyInloName,
        item.plantInloName,
        item.qnaMenuClCd,
        item.qnaTitle,
        item.regDtm,
        item.qnaStCd,
        <FxOpenButton    // 상세보기 버튼 추가
            key={`${item.qnaNo}-${item.qnaStCd}`}  // key prop 추가
            title={item.qnaStCd === "답변완료" ? "답변 확인" : "답변 등록"}
            opObj={opObjCheck}
            selectedData={item}
            className="fpactButton"
            refershGridData={submitBtnClick}
        />
    )
  })

  useEffect(() => {
    getQnaMenuClCd();
    submitBtnClick();
  }, []);

  const getQnaMenuClCd = async () => {
    const uri = "vup/getQnaMenuClCd"
    try {
        const res = await FxmsData.GET(uri);
        setFetchQnaMenuClCd(res.data);
    } catch (e) {
        console.log("getQnaMenuClCd error ........", e);
    }
  }

  const handleSelectData = (event) => {
    const { id, value, name } = event.target;
    setSelected((prev) => {
      return { ...prev, [name]: value };
    })    
  }

  return (
    <>
    <div className="predict">
      <div className="FxCrudFilter">
        <div className="FxFilterLeft">
          <label className="FxLabelSearch"></label>        
          <select className="FxSelectSearch" name="qnaMenuClCd" onChange={handleSelectData}>
            <option value="ALL">문의분류 전체</option>
            {fetchQnaMenuClCd?.map((item) => (
              <option key={item.cdCode} value={item.cdCode} name="qnaMenuClCd">{item.cdName}</option>
            ))}
          </select>
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" name="qnaClCd" value={selected.qnaClCd} onChange={handleSelectData}>
            <option value="TITLE">제목</option>
            <option value="ALL">제목+내용</option>
          </select>
        </div>
        <div className="FxFilterRight">
          <input className="FxTextFieldSearch" type="text" name="txtSearch" value={selected.txtSearch} onChange={handleSelectData} style={{minWidth: '200px', width: '200px'}}></input>
          <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick}/>
        </div>
      </div>
      <div className="FxCrudDataGrid">     
        <div className="FxMuiTable">
          <MuiTable
            tableRowDataList={UI_5_4_tableRow}
            rows={resultRow}
            menuFullName='관리자/Q&A'
          />
        </div>
      </div>
    </div>
    </>
  )

}